var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0387 7.99326L12.5068 6.46142L2.41667 16.5516V18.0834H3.9485L14.0387 7.99326ZM15.5705 6.46142L17.1023 4.92959L15.5705 3.39776L14.0387 4.92959L15.5705 6.46142ZM4.8455 20.2501H0.25V15.6535L14.8046 1.09892C15.0077 0.89583 15.2832 0.781738 15.5705 0.781738C15.8578 0.781738 16.1333 0.89583 16.3364 1.09892L19.4012 4.16367C19.6043 4.36683 19.7184 4.64233 19.7184 4.92959C19.7184 5.21685 19.6043 5.49235 19.4012 5.69551L4.84658 20.2501H4.8455Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.f485b4943040263ac5673acff89de123.svg";
export { ForwardRef as ReactComponent };